import { SHARED_FILTERS } from './send-mail-stepper-shared-filters';

export const SEND_MAIL_STEPPER_REPLY_FILTERS = {
  path: '/mailing/stepper/reply/:id',
  filters: SHARED_FILTERS
};